import { LazyLoadImage as BaseLazyLoadImage } from 'react-lazy-load-image-component'

const LazyLoadImage = BaseLazyLoadImage as any

import MaximizeButton from '@/presentation/components/Carousel/components/MaximizeButton'

interface ImageItemProps {
  filePath: string
  onMaximizeButtonClick: () => void
}

const ImageItem: React.FC<ImageItemProps> = ({
  filePath,
  onMaximizeButtonClick
}) => (
  <div key={filePath} className="cursor-pointer px-2">
    <MaximizeButton onClick={onMaximizeButtonClick} />

    <LazyLoadImage
      className="size-full rounded-2xl bg-cover bg-center bg-no-repeat object-cover object-center md:max-h-[600px]"
      src={filePath}
      alt="Divergence item photo"
      width="100%"
      effect="blur"
    />
  </div>
)

export default ImageItem
